import { Container, Row } from "reactstrap";
import BasicCard from "./BasicCard";
import { Breadcrumbs } from "../../../AbstractElements";
import { BasicCardTitle, BonusUi } from "../../../Constants/Constants";
import FlatCard from './FlatCard'
import WithoutShadow from './WithoutShadow'
import HeadingIcon from './HeadingIcon'
import DarkCard from './DarkCard'
import InfoColorCard from './InfoColorCrad'
import { Fragment } from "react/jsx-runtime";

const BasicCardContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={BasicCardTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BasicCard />
          <FlatCard/>
          <WithoutShadow/>
          <HeadingIcon/>
          <DarkCard/>
          <InfoColorCard/>
        </Row>
      </Container>
    </Fragment>
  );
};
export default BasicCardContainer;
